import React,{useEffect} from 'react';
// import { useSelector, useDispatch } from 'react-redux';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home.jsx'
import Nav from './components/Nav.jsx'
import Booking from './pages/Booking.jsx'
import Footer from './components/Footer.jsx'
import ScrollToTop from './components/ScrollToTop'
import CheckBooking from './pages/CheckBooking.jsx'
import { requestData } from './js/api.js'
import { useDispatch } from 'react-redux';
import {setInitData } from "./redux/data.js";


function App() {
  const dispatch = useDispatch();
  useEffect(() => {
    getInit()
  }, [])    // eslint-disable-line

  const getInit = async () => {
    try {
      let data = await requestData('GET', 'init-data');
      dispatch(setInitData(data))

    } catch (error) {
      console.error('Error:', error.message);
    }
  }
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Nav />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/booking/:id" element={<Booking />} />
          <Route path="/viewbooking/:orderID/:lastname" element={<CheckBooking />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;